import { SERVICES_LIST } from "shared/constants/services";
import { gtagsActions, gtagsCategories, gtagsSend } from "utils/gtagsUtils";
import { DROPDOWN_TYPES } from "./DropDown";

export default [
  {
    path: "/#branches",
    i18nLabel: "find-agency",
    onClick: () => gtagsSend(gtagsCategories.SEARCH, gtagsActions.FIND_AGENCY),
  },
  {
    path: "/#services",
    i18nLabel: "services",
    dropdownType: DROPDOWN_TYPES.mega,
    withDropDown: true,
    items: SERVICES_LIST,
  },
  {
    path: "/chaabi-payment",
    i18nLabel: "become-merchant-accepting-by-card",
    onClick: () =>
      gtagsSend(
        gtagsCategories.LEAD,
        gtagsActions.BECOME_MERCHANT_ACCEPTING_BY_CARD
      ),
  },
  {
    path: "/become-franchisee",
    i18nLabel: "open-agency",
    onClick: () =>
      gtagsSend(gtagsCategories.LEAD, gtagsActions.BECOME_FRANCHISE),
  },
  {
    path: "/#contact-us",
    i18nLabel: "contact",
  },
];
